module.exports = __webpack_public_path__ + "img/login-5defebrero.91770982.svg";